// request.js
import Vue from "vue";
import axios from "axios";
import qs from "qs";
import store from "@/store";
import { Message } from "element-ui";
import api from "@/api/api";
import md5 from "js-md5";

// console.log("================================",api)
// 创建 axios 实例
// let baseUrl = '/'
// if (process.env.NODE_ENV === 'production') {
//   baseUrl = 'http://commodity.cardhobby.cn'
// } else if (process.env.NODE_ENV === 'development') {
//   baseUrl = process.env.VUE_APP_BASEURL
// }
let baseUrl = process.env.VUE_APP_BASEURL,
  userApi = process.env.VUE_APP_USER,
  expressApi = process.env.VUE_APP_EXPRESS;

let LOCAL_API_URL = process.env.VUE_APP_LOCAL_API_URL;
// 响应时间
axios.defaults.timeout = 30 * 1000;
// 配置cookie
// axios.defaults.withCredentials = true
// 配置请求头
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
//axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";
// axios.defaults.headers.common['Authorization'] = '1';

// 配置接口地址
//axios.defaults.baseURL = '';//baseUrl

/* token 测试 */
// if(store.state.test){
//   axios.defaults.headers.common['token'] = store.state.ChToken;
// }

// var loadingInstance;
// POST传参序列化(添加请求拦截器)
var requestMethod = "";
axios.interceptors.request.use(
  config => {
    let cUrl = config.url.split("/");
    // console.log("config.url:", cUrl[2], userApi+expressApi, (userApi+expressApi).indexOf(cUrl[2]));
    if ((userApi + expressApi).indexOf(cUrl[2]) > -1 && store.state.UserToken) {
      //用户判断user接口
      config.headers.common["Authorization"] =
        "Bearer " + store.state.UserToken;
    }
    // if(cUrl.includes('discern')){
    //   console.log("discerndiscern:");
    //   config.headers['Content-Type'] = 'application/json';
    // }

    if (config.method === "post") {
      console.log("config:,", config)
      if (cUrl.includes('wallet')) {
        //钱包接口
        var _data = qs.stringify(config.data);
        console.log("data:", _data);
        config.headers.common['Authorization'] = md5(_data + store.state.walletKey);
      }
      if (store.state.ChToken) {
        // config.headers.common['Authorization'] = "Bearer " + store.state.ChToken;
        // config.headers.common['token'] = store.state.ChToken;
      }
    }
    requestMethod = config.method;
    // console.log("config:", config);

    store.commit("setLoading", true);
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  res => {
    console.log("返回状态判断(添加响应拦截器):", res);
    //console.log("loading-ing:", store.state.loading);

    var ResData = res.data;
    var _Result = ResData.result != undefined ? ResData.result : ResData.Result,
      _Msg = ResData.msg != undefined ? ResData.msg : ResData.Msg;
    if (_Result == -1) {
      //用户冻结，请求状态-1个数累加（解决错误提示1次）
      store.state.MinusOne = store.state.MinusOne + 1;
    }
    // console.log(_Result, _Msg, store.state.MinusOne);
    if (requestMethod == "get") {
      if (
        _Result <= 0 &&
        _Msg != "" &&
        store.state.MinusOne <= 1 &&
        _Msg.indexOf("Error") == -1
      ) {
        Message.error(_Msg);
      }
    } else {
      if (_Result <= 0 && _Msg != "" && store.state.MinusOne <= 1) {
        Message.error(_Msg);
      }
    }
    if (_Result == -1) {
      //用户冻结，退出登录状态
      setTimeout(() => {
        store.dispatch("Logout");
      }, 1000);
    }
    store.commit("setLoading", false);
    return ResData;
  },
  error => {
    store.commit("setLoading", false);
    console.log("axios.error", error);
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = "请求错误(400)";
          break;
        case 401:
          error.message = "未授权，请重新登录(401)";
          break;
        case 403:
          error.message = "拒绝访问(403)";
          break;
        case 404:
          error.message = "请求出错(404)";
          break;
        case 408:
          error.message = "请求超时(408)";
          break;
        case 500:
          error.message = "服务器错误(500)";
          break;
        case 501:
          error.message = "服务未实现(501)";
          break;
        case 502:
          error.message = "网络错误(502)";
          break;
        case 503:
          error.message = "服务不可用(503)";
          break;
        case 504:
          error.message = "网络超时(504)";
          break;
        case 505:
          error.message = "HTTP版本不受支持(505)";
          break;
        default:
          error.message = `连接出错!`;
      }
      error.message && Message.error(error.message);
    }
    return Promise.reject(error);
  }
);
// 发送请求
export function post(url, params, type) {
  console.log(url, params);
  if (params == "none") {
    params = {};
  } else if (params["UserApi"] == "UserApi") {
    /*除worldapi的其他接口*/
    if (store.state.UserInfo.Id) {
      // params["memberId"] = store.state.UserInfo.Id;
      params["UserId"] = store.state.UserInfo.Id;
    }
  } else if (type == "WalletApi") {
    // params["MemberId"] = store.state.UserInfo.MappingUserId;
  } else {
    params["lag"] = store.state.webConfig.lag;
    params["memberId"] = store.state.UserInfo.MappingUserId;
    params["operator_id"] = store.state.UserInfo.MappingUserId;
    params["token"] = store.state.ChToken;
    params["device"] = store.state.webConfig.device;
    params["version"] = store.state.webConfig.version;
    params["appname"] = store.state.webConfig.appname;
  }
  console.log("** POST Params**", params);
  let API_URL_POST = LOCAL_API_URL + "/Post";
  let api_config_post = {
    //默认中间件请求（传参）方式
    url: API_URL_POST,
    prm:
      "url=" +
      encodeURIComponent(api[url]) +
      `&ContentType=application/json` + //application/json /${encodeURIComponent('application/x-www-form-urlencoded;charset=UTF-8')}
      "&Param=" +
      encodeURIComponent(JSON.stringify(params))
  };
  if (!store.state.Middleware) {
    //接口非中间件, POST传参方式
    if (type != 'WalletApi') {
      params = qs.stringify(params);
    }
    api_config_post = {
      url: api[url],
      prm: params
    };
  }
  return new Promise((resolve, reject) => {
    axios
      .post(api_config_post.url, api_config_post.prm)
      //.post(api[url], params)
      .then(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      )
      .catch(err => {
        reject(err);
      });
  });
}
export function get(url, params, type) {
  var tToken = "";
  switch (type) {
    case "BuyerId":
      /*议价memberId：obj.CreateUser*/
      tToken = `token=${store.state.ChToken}&lag=${store.state.webConfig.lag}&operator_id=${store.state.UserInfo.MappingUserId}`;
      break;
    case "UserApi":
      /*除worldapi的其他接口*/
      tToken = ``;
      break;
    default:
      let mid =
        process.env.NODE_ENV === "production" || !store.state.test
          ? store.state.UserInfo.MappingUserId
          : store.state.UserInfo.Id;
      tToken = `token=${store.state.ChToken}&lag=${store.state.webConfig.lag}&memberId=${mid}&operator_id=${store.state.UserInfo.MappingUserId}`;

      break;
  }
  if (params == "none") {
    params = "";
  } else {
    params = params ? params + "&" + tToken : "?" + tToken;
  }
  console.log(api[url] + params);

  let API_URL_GET = LOCAL_API_URL + "/Get";
  let api_config_get =
    API_URL_GET + "?url=" + encodeURIComponent(api[url] + params);
  if (!store.state.Middleware) {
    //接口非中间件, GET传参方式
    api_config_get = api[url] + params;
  }
  return new Promise((resolve, reject) => {
    axios
      .get(api_config_get)
      //.get(api[url] + params)
      // .get(url, {
      //   params: params
      // })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export let ExportOrderReport = api.ExportOrderReport;//报表、对账单下载链接



// WEBPACK FOOTER //
// ./src/api/axiosConfig.js